// extracted by mini-css-extract-plugin
export default {"container":"ToolsDescription_container__FJvqC"};